<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TZXT9v/tc-custom/9781446370827.jpg?1728353358225" alt="This image is the cover for the book Hooked!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hooked!
      </h1>
      <p class="bookDescription body article font2">
        <b>With this eclectic collection of forty designs, learn to crochet motifs that can be applied an endless number of projects.</b><br/><br/>If you love crochet, you will adore this collection of over forty cute motifs including classic hearts and flowers, as well as more quirky designs for skulls, mushrooms, and seasonal-themed motifs such as gingerbread men. The motifs are fun, original, and quirky and the patterns are suitable for crocheters of all abilities, even novices.<br/><br/>As well as the motif designs, this collection includes tons of practical ideas for how to use the motifs in simple projects such as bunting and key rings, as well as embellishments on scarves and bags. There are seasonal projects for Christmas and Halloween so you can get festive and crochet decorations and gifts for family and friends.<br/><br/><b>Praise for <i>Hooked!</i></b><br/><br/><b>“<i>Hooked!</i> has 40 of the most adorable and whimsical motifs that are great for embellishing any project! There are so many great projects in this book. You can learn how to make little flowers, stars, animals, hearts, and more! There are 40 different motifs to choose from and they are great for creating buntings, afghan squares, decorating garments and so many other applications.” —The Stitchin’ Mommy</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michelle Delprat, Cecilé Delprat, Sylvie Delprat
      </h2>
      
      <p class="authorDescription body article">Michelle Delprat and her daughters Cécile and Sylvie have embraced their family tradition that celebrates a love for all things handmade. With their fair trade business, Emalisa, they see crafting as a way of life.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles is an imprint of F&W Media International, Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f29129a6